import request from 'crm/utils/request'
import {format} from 'utils'
import api from 'crm/common/api/wechat-program'

export async function list() {
    return request(api.list.url)
}

export async function create(payload) {
    return request(api.create.url, {
        method: api.create.type,
        body: payload.body,
    })
}

export async function update(payload) {
    return request(format(api.update.url, {id: payload.id}), {
        method: api.update.type,
        body: payload.body,
    })
}

export async function remove(payload) {
    return request(format(api.remove.url, {id: payload.id}), {
        method: api.remove.type,
    })
}
